import {ChangeEvent, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'

import {useImportProduct} from 'src/feature/tasks/context/useMutation'

function Import({tableName}: {tableName: string}) {
  const intl = useIntl()
  const {mutateAsync, isLoading} = useImportProduct()

  const inputRef = useRef<HTMLInputElement>(null)
  const [modal, setModal] = useState(false)

  const handleImport = async (event: ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.files)

    const file = event.target.files?.[0]

    if (!file) return
    await mutateAsync({file})

    // remove inputref value remove
    inputRef.current!.value = ''
    setModal(false)
  }

  return (
    <>
      <input type='file' ref={inputRef} onChange={handleImport} hidden />
      {/* <Modal show={modal} onHide={() => setModal(false)}>
        <Modal.Header>
          <Modal.Title>Import Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Upload your file here to import product data from your file.{' '}
          <a href='/product-upload.xlsx' target='_blank' rel='noreferrer' download>
            Download Template
          </a>
          <input type='file' ref={inputRef} onChange={handleImport} hidden />
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-light'
            onClick={() => setModal(false)}
          >
            Cancel
          </button>
          <button
            type='button'
            className='btn btn-primary'
            disabled={isLoading}
            onClick={() => {
              inputRef.current?.click()
            }}
          >
            {isLoading ? 'Importing...' : 'Import'}
          </button>
        </Modal.Footer>
      </Modal> */}
      {/* <button
        type='button'
        className='btn btn-light'
        onClick={() => {
          // inputRef.current?.click()
          setModal(true)
        }}
      >
        <i className='ki-duotone ki-exit-up fs-2'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {intl.formatMessage({ id: 'GLOBAL.IMPORT.PRODUCT' })}
      </button>
      <a
        type='button'
        className='btn btn-light'
        href='/product-upload.xlsx' target='_blank' rel='noreferrer' download
      >
        <i className='ki-duotone ki-file-added fs-2'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {intl.formatMessage({ id: 'GLOBAL.IMPORT.PRODUCT.TEMPLATE' })}
      </a> */}

      <button
        type='button'
        className='btn btn-light'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <i className='ki-duotone ki-exit-up fs-2'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {isLoading
          ? intl.formatMessage({id: 'GLOBAL.IMPORTING'})
          : intl.formatMessage({id: 'GLOBAL.IMPORT.PRODUCT'})}
      </button>
      <div
        // id='kt_datatable_example_import_menu'
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 fw-semibold fs-7 w-250px py-4'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            href='/product-upload.xlsx'
            target='_blank'
            rel='noreferrer'
            download
          >
            {intl.formatMessage({id: 'GLOBAL.IMPORT.PRODUCT.TEMPLATE'})}
            {/* <span className='ms-1 text-danger'>*</span> */}
          </a>
        </div>
        <div className='menu-item px-3'>
          <span
            className='menu-link px-3'
            onClick={() => {
              inputRef.current?.click()
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.IMPORT.PRODUCT'})}
          </span>
        </div>
      </div>
    </>
  )
}

export default Import
